// The environments a build of this console can operate on, and the parser
// both ends share: vite.config.ts resolves one at build time and injects it as
// import.meta.env.VITE_ADMIN_ENV; src/lib/env.ts re-validates it on the way in.
// Pure on purpose -- no import.meta, no process -- so Vite's config loader and
// the bundle can both import it.
export const ADMIN_ENVS = ['dev', 'testnet', 'prod'] as const;
export type AdminEnv = (typeof ADMIN_ENVS)[number];

export function parseAdminEnv(raw: string | undefined): AdminEnv {
  const match = ADMIN_ENVS.find((env) => env === raw);
  if (match === undefined) {
    throw new Error(
      `VITE_ADMIN_ENV is ${JSON.stringify(raw)}; expected one of ${ADMIN_ENVS.join(', ')}. vite.config.ts injects it.`,
    );
  }
  return match;
}
